import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import '../styles/recentPicks.css';

/**
 * The small "Recent" heading over a picker's recent picks (utils/recentPicks.js),
 * and the line under them where the rest of the list starts.
 */
export const RecentPickLabel = () => (
    <div className="recent-pick-label">
        <FontAwesomeIcon icon={faClockRotateLeft} /> Recent
    </div>
);

export const RecentPickDivider = () => <div className="recent-pick-divider" role="separator" />;

export default RecentPickLabel;
